module.exports = __webpack_public_path__ + "static/media/YM17_4.5cf4985c.jpg";